<template>
  <div>
    <div class="overlay">
        <div class="img-style edit-button">
        <img src="@/assets/meal_history/アセット 20@2x.png" @click="back">
         <img src="@/assets/meal_history/アセット 21@2x.png" @click="pushedRecord">
         </div>
    </div>
  </div>
</template>

<script>
export default {
    name:"InputEditWater",
    props:["isfirstRecord"],
    methods: {
        back() {
            this.$emit("handle-hide")
        },
        pushedRecord() {
          if (this.isfirstRecord) this.$emit("handle-water-put")
          if (!this.isfirstRecord) this.$emit("handle-water-post")
        }
    }
}
</script>

<style scoped>
.overlay {
  /*要素を重ねた時の順番*/
  z-index: 1;
  /*画面全体を覆う設定*/
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  /*画面の中央に要素を表示させる設定*/
  /* display: flex;
  align-items: center;
  justify-content: center; */
}

.edit-button {
    position: absolute;
    bottom: 15%;
}
.edit-button img {
    margin: 1%;
}
</style>


// WEBPACK FOOTER //
// src/molecules/InputEditWater.vue